import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = { trigger: String }

  connect() {
    console.log(this.triggerValue)

    this.tooltip = new Tooltip(this.element, {
      trigger: this.triggerValue || "hover focus",
    })
  }

  clicked(event) {
    this.tooltip.toggle()
  }
}
